import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
import { painPoints } from '../data/content';
export function Pain() {
  return <section className="bg-ink py-16 text-cream sm:py-20" aria-labelledby="pain-title" data-id="element-94" data-mp="1nypwi5x339ux">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-95" data-mp="1izv6ok0p8l1b">
        <h2 id="pain-title" className="font-display text-3xl font-black sm:text-4xl" data-id="element-96" data-mp="1e3eglk9xvwll">
          El problema no es tu falta de talento
        </h2>
        <p className="mx-auto mt-4 max-w-2xl text-lg text-cream/70" data-id="element-97" data-mp="1a34e4hlcvobh">
          El problema es que internet está lleno de información suelta:
        </p>

        <ul className="mt-10 grid gap-4 text-left sm:grid-cols-3" data-id="element-98" data-mp="10af0bg2c1ycz">
          {painPoints.map((point, index) => <motion.li key={point} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.4
        }} transition={{
          duration: 0.45,
          delay: index * 0.08
        }} className="rounded-2xl border border-cream/15 bg-white/5 p-6" data-id="element-99" data-mp="vd6jpjwu22du" data-mpi={index}>
              <span className="mb-4 flex h-9 w-9 items-center justify-center rounded-full bg-terracotta/25 text-terracotta-light" data-id="element-100" data-mp="23nq0fb81r13d">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-101" data-mp="1p04wjf3ckxue" />
              </span>
              <p className="text-[15px] leading-relaxed text-cream/85" data-id="element-102" data-mp="1txevpmgjgnvf">{point}</p>
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-10 max-w-2xl text-lg leading-relaxed text-cream/80" data-id="element-103" data-mp="2hp2flkfduyo7">
          Pasar horas tejiendo para terminar frustrada porque el resultado no es lo que esperabas es
          lo que hace que muchas abandonen este hermoso arte.{' '}
          <strong className="font-bold text-cream" data-id="element-104" data-mp="2coo4tumedamh">
            Es hora de dejar de adivinar y empezar a crear.
          </strong>
        </p>
      </div>
    </section>;
}